import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import EmptyPoolExclusionCriteriaContMain from "presentation/view/container/Criteria/EmptyPoolExclusionCriteriaContMain";

CommonEntrypoint(<EmptyPoolExclusionCriteriaContMain/>)